//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Validation.js";
let d=[[[0,"CheckName",1,0],[0,"Formula",0,0],[0,"ParentRequirement",1,"Validate.Requirement",0],[0,"SaveResultsToTeamcenterOption",1,0]],[[["formula"],"SetFormula",{},1,0]],[]];
SPLM.Validate.RequirementCheck = class extends SPLM.Validation{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.RequirementCheck";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.RequirementCheck.SaveResultsToTeamcenterOptions = Object.freeze({
    "DoNotSave" : "DoNotSave", "SaveIfPassed" : "SaveIfPassed", "AlwaysSave" : "AlwaysSave"});

export default SPLM;